var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7526 11.5051H0.247413C0.0824642 11.5051 0 11.3814 0 11.2577C0 11.134 0.123701 11.0103 0.247413 11.0103H19.7526C19.9175 11.0103 20 11.134 20 11.2577C20 11.3814 19.9175 11.5051 19.7526 11.5051Z",
    fill: ""
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.77327 11.5053H1.77329C1.60834 11.5053 1.52588 11.3815 1.52588 11.2578V4.86606C1.52588 4.70112 1.64958 4.61865 1.77329 4.61865H5.77327C5.93822 4.61865 6.02068 4.74235 6.02068 4.86606V11.2578C6.02068 11.3815 5.93822 11.5053 5.77327 11.5053ZM2.06193 10.9692H5.52586V5.1135H2.06193V10.9692Z",
    fill: ""
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0003 11.5052H8.00034C7.83539 11.5052 7.75293 11.3815 7.75293 11.2578V2.55674C7.75293 2.39179 7.87663 2.30933 8.00034 2.30933H12.0003C12.1653 2.30933 12.2478 2.43303 12.2478 2.55674V11.2578C12.289 11.3815 12.1653 11.5052 12.0003 11.5052ZM8.28898 10.9691H11.7529V2.80415H8.28898V10.9691Z",
    fill: ""
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2269 11.5052H14.2269C14.062 11.5052 13.9795 11.3814 13.9795 11.2577V0.247438C13.9795 0.0824893 14.1032 0 14.2269 0H18.2269C18.3919 0 18.4743 0.123726 18.4743 0.247438V11.2577C18.5156 11.3814 18.3919 11.5052 18.2269 11.5052ZM14.5156 10.9691H17.9795V0.49485H14.5156V10.9691Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg9);
export default __webpack_public_path__ + "static/media/9.56701f1d2a4bd1a2b9b5d17d0d6e66b2.svg";
export { ForwardRef as ReactComponent };